import {Observable} from 'rxjs';
import {educatAPI} from './provider/educatAPI';

export function getAdminMentorsAPI(authToken: string | null, params: any): Observable<any> {
    let headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    return educatAPI.get(
        `admin-mentors`,
        params,
        headers
    );
}
